import { Sorter } from 'modules/common/components';
import { useSort } from 'modules/common/hooks';
import { options } from 'modules/donor/components/TeamsCardList/TeamsCardListSorter/options';
import { TeamListSort } from 'modules/donor/components/TeamsTable/interfaces';
import { FC } from 'react';

const useTeamListSort = () => useSort<TeamListSort>();

type PropTypes = {
  sorting: ReturnType<typeof useTeamListSort>;
};

export const TeamsCardListSorter: FC<PropTypes> = ({ sorting }) => (
  <Sorter sorting={sorting as ReturnType<typeof useSort>} options={options} />
);
